import React from 'react';
import Linkify from 'react-linkify';
import { cn } from "@/lib/utils";

// Map sideways emoticons to Unicode emojis
const emoticonMap = {
    ':)': '😊',
    ':-)': '😊',
    ':(': '😢',
    ':-(': '😢',
    ':D': '😃',
    ':-D': '😃',
    '<3': '❤️',
    ':P': '😛',
    ':-P': '😛',
    ';)': '😉',
    ';-)': '😉',
    ':O': '😮',
    ':-O': '😮',
    ':|': '😐',
    ':-|': '😐',
    ':/': '😕',
    ':-/': '😕',
    ':\\': '😕',
    ':-\\': '😕',
    ':*': '😘',
    ':-*': '😘',
    '>:(': '😠',
    '>:-(': '😠',
    ':\'(': '😭',
    ':\'-(': '😭',
    'XD': '😆',
    'xD': '😆',
    'xP': '😝',
    'XP': '😝',
};

// Convert emoticons to emojis
const convertEmoticons = (text) => {
    if (!text || typeof text !== 'string') return text;
    
    let converted = text;
    
    // Sort by length (longest first) to match longer patterns first (e.g., ':-)' before ':)')
    const patterns = Object.keys(emoticonMap).sort((a, b) => b.length - a.length);
    
    for (const pattern of patterns) {
        // Use word boundary or space to avoid partial matches
        // But allow emoticons at start/end of string or after/before punctuation
        const regex = new RegExp(
            `(?<![\\w])${pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?![\\w])`,
            'g'
        );
        converted = converted.replace(regex, emoticonMap[pattern]);
    }
    
    return converted;
};

const LinkifyText = ({ children, className, ...props }) => {

    const LinkHelper = ({ href, children }) => (
        <a 
            href={href} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:underline break-words"
        >
            {children}
        </a>
    );

    // Ensure children is a string
    const textContent = typeof children === 'string' ? children : String(children || '');
    
    // Convert emoticons to emojis
    const textWithEmojis = convertEmoticons(textContent);

    return (
        <p 
            className={cn("break-words max-w-full", className)}
            {...props}
        >
            <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
                <LinkHelper href={decoratedHref} key={key}>
                    {decoratedText}
                </LinkHelper>
            )}>
                {textWithEmojis}
            </Linkify>
        </p>
    );
};

export default LinkifyText;
